import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=4291a1d9&scoped=true"
import script from "./backend.vue?vue&type=script&lang=js"
export * from "./backend.vue?vue&type=script&lang=js"
import style0 from "./backend.vue?vue&type=style&index=0&id=4291a1d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291a1d9",
  null
  
)

export default component.exports